import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import { useAlert } from '../../../../components/Notification';
import createAxiosInstance from '../../../../api';
import CreateRole from './create';
import Customselect from '../../../../components/CustomSelect';
import { Unauthorized } from '../../../../components/index';
import { ErrorMessage } from '../../../../permissionErrorMessage/PermissionMessage';
interface Policy {
  id: string;
  displayName: string;
  displayDesc: string;
}

interface ListPermission {
  groupName: string;
  policies: Policy[];
}

interface Props {
  pagePermissionIDs: unknown;
}

const EditRoleManagement: React.FC<Props> = ({ pagePermissionIDs }) => {
  const showAlert = useAlert();
  const axiosInstance = createAxiosInstance();

  const { name, id } = useParams();
  const [roleEdit, setRoleEdit] = useState(false);
  const [allID, setAllID] = useState<string[]>([]);
  const [assignPermission, setAssignPermission] = useState<string[]>([]);
  const [listPermission, setListPermission] = useState<ListPermission[]>([]);
  const canUpdateRoles =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('roles::update');
  const canUpdatePermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('roles::assignPermission');

  const canGetRole =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('roles::get');

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['roles::get'] || ''}</li>
      </ul>
    </section>
  );

  const submitedData = () => {
    axiosInstance
      .post('/assignPermission', { roleID: id, permissions: assignPermission })
      .then(() => {
        showAlert('Role Update Successful', 'success');
      })
      .catch(() => {
        showAlert('Failed Role Update', 'warning');
      });
  };

  const getRoleDetails = () => {
    axiosInstance
      .post('/getRolePermission', { roleID: id })
      .then((response) => {
        if (response.data.data.permissions) {
          setAssignPermission(response.data.data.permissions);
        }
      })
      .catch(() => {
        setAssignPermission([]);
      });
  };

  const getPermissionList = () => {
    if (canGetRole) {
      axiosInstance
        .get('/listPermission')
        .then((response) => {
          getRoleDetails();
          const data = response.data.data;
          const policyIds = data.flatMap((item: ListPermission) =>
            item.policies.map((policy) => policy.id),
          );
          setAllID(policyIds);
          setListPermission(data);
        })
        .catch(() => {
          setListPermission([]);
        });
    }
  };

  useEffect(() => {
    getPermissionList();
  }, [canGetRole]);

  return (
    <>
      {!canGetRole ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          {roleEdit ? (
            <CreateRole />
          ) : (
            <div className="content rolemanagement">
              <div className="rolemanagement-header">
                <div className="role_edit_btn">
                  <b>{name}</b>
                  {name && id && canUpdateRoles && (
                    <Button
                      className="btn-transparent border-0 edit-role-icon"
                      onClick={() => setRoleEdit(true)}
                    >
                      <i className="edit-icon bi bi-pencil-square bi-lg"></i>
                    </Button>
                  )}
                </div>
                <p className="table-header-instruction m-0">
                  Modify or finalize permission here for this role
                </p>
              </div>
              <Customselect
                permission={listPermission}
                Ids={allID}
                assignPermission={assignPermission}
                setAssignPermission={setAssignPermission}
              />
              {canUpdatePermission && (
                <div className="submit-btn d-flex justify-content-end">
                  <Button
                    color="primary"
                    onClick={() => {
                      submitedData();
                    }}
                  >
                    Update
                  </Button>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default EditRoleManagement;
